import { createSlice } from "@reduxjs/toolkit";

const VendorUserDetailsSlice = createSlice({
  name: "vendorUserDetails",
  initialState: {
    userDetails: {},
  },
  reducers: {
    setVendorUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
  },
});

export const { setVendorUserDetails } = VendorUserDetailsSlice.actions;
export default VendorUserDetailsSlice.reducer;
